<p-button
    [icon]="icon"
    [styleClass]="'p-button-rounded ' + colorClass"
></p-button>
